import * as institutionIconSelectors from './institutionIconSelectors';
import * as institutionIconTypes from './institutionIconTypes';
import * as institutionLoginsActions from './institutionLoginsActions';
import { institutionLoginsReducer } from './institutionLoginsReducer';
import institutionLoginsSagas, {
  institutionLoginsDumpUpdater,
  institutionLoginsNudgeUpdater,
} from './institutionLoginsSagas';
import * as institutionLoginsSelectorsBase from './institutionLoginsSelectors';
import * as institutionLoginsTransformers from './institutionLoginsTransformers';
import * as institutionLoginsTypes from './institutionLoginsTypes';
import * as institutionLoginsUtils from './institutionLoginsUtils';

const institutionLoginsSelectors = { ...institutionLoginsSelectorsBase, ...institutionIconSelectors };
const { INSTITUTION_LOGINS_REDUCER_KEY } = institutionLoginsTypes;

const INSTITUTION_LOGINS_VERSION_NUMBER = 8;

export {
  INSTITUTION_LOGINS_REDUCER_KEY,
  INSTITUTION_LOGINS_VERSION_NUMBER,
  institutionIconTypes,
  institutionLoginsActions,
  institutionLoginsDumpUpdater,
  institutionLoginsNudgeUpdater,
  institutionLoginsReducer,
  institutionLoginsSagas,
  institutionLoginsSelectors,
  institutionLoginsTransformers,
  institutionLoginsTypes,
  institutionLoginsUtils,
};
